import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} fill="#fff" />
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} stroke={theme["#B4E3E1"]} />
        <path
            d="M28.333 25.833v2.5H11.666v-2.5c0-.458.375-.833.833-.833h15c.459 0 .834.375.834.833z"
            fill={theme["#0D968F"]}
            stroke={theme["#0D968F"]}
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.833 19.166h-1.667V25h1.667v-5.834zM19.167 19.166H17.5V25h1.667v-5.834zM22.5 19.166h-1.666V25h1.667v-5.834zM25.833 19.166h-1.667V25h1.667v-5.834zM29.167 28.959H10.834a.63.63 0 01-.625-.625.63.63 0 01.625-.625h18.333a.63.63 0 01.625.625.63.63 0 01-.625.625z"
            fill={theme["#0D968F"]}
        />
        <path
            d="M27.808 14.792l-7.5-3a.975.975 0 00-.617 0l-7.5 3a.892.892 0 00-.525.775v2.766c0 .459.375.834.833.834h15a.836.836 0 00.834-.834v-2.766a.892.892 0 00-.525-.775zm-7.809 2.291c-.691 0-1.25-.558-1.25-1.25 0-.691.559-1.25 1.25-1.25.692 0 1.25.559 1.25 1.25 0 .692-.558 1.25-1.25 1.25z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent